import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  width: 320px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', sans-serif;
`;

const Header = styled.div`
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
`;

const PlanRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

const PlanLogo = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

const PlanDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const AmountRow = styled.div`
  font-size: 16px;
  margin: 12px 0;
`;

const Divider = styled.hr`
  border: none;
  height: 1px;
  background: #eee;
  margin: 16px 0;
`;

const Total = styled.div`
  font-size: 18px;
  font-weight: bold;
`;

const SummaryCard = ({ data }) => {
  const planDetails = data?.healthMapping?.['health-fg']?.rawRes;

  return (
    <Card>
      <Header>Summary</Header>
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontSize: '14px', color: '#555' }}>
          Plan for:{' '}
          <strong>
            {Object?.entries(data?.selectedMembers)
              .filter(([key, value]) =>
                key === 'child' ? value.length > 0 : value
              )
              .map(([key]) => key)
              .join(', ')}
          </strong>
        </div>
      </div>

      <PlanRow>
        <PlanLogo
          src={planDetails?.sluginfo?.logo || 'https://via.placeholder.com/50'}
        />
        <PlanDetails>
          <div style={{ fontWeight: 600 }}>
            {planDetails?.sluginfo?.name || 'Plan Name'}
          </div>
          <div style={{ fontSize: '13px', color: '#555' }}>
            Cover: ₹{data?.sumAssured || '0'} Lakh
          </div>
        </PlanDetails>
      </PlanRow>

      <AmountRow>
        Premium - {`${data?.tenure} Years` || '1 Year'}:{' '}
        <strong>
          ₹{planDetails?.priceDetails?.PremiumWithTax?.toLocaleString()}
        </strong>
      </AmountRow>

      <Divider />

      <Total>
        Total premium: ₹
        {planDetails?.priceDetails?.PremiumWithTax?.toLocaleString()}
      </Total>
    </Card>
  );
};

export default SummaryCard;
